import { useNavigate, useOutletContext } from "react-router";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import styles from "./UnderwritingHome.module.scss";
import { HiArrowNarrowRight as RightIcon } from "react-icons/hi";
import {
  LendingStatus,
  PcColdStates,
  UnderwritingColdState,
  UnderwritingFormStatus,
  underwritingRoutes,
} from "../../../interfaces/interfaces";
import usePageTitle from "../../../components/Hooks/usePageTitle";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MdCheckCircle as CheckCircleIcon } from "react-icons/md";
import { RestS } from "../../../rest/rest-service";
import CircularLoader from "../../../components/common/CircularLoader/CircularLoader";
import HeaderTitle from "../../../components/common/HeaderTitle";
import LandingImage from "../../../assets/images/supplierPayments/underwriting - landing 4x webp no shadow.webp";
import TopShadowImage from "../../../assets/images/supplierPayments/landing 1x top shadow svg 2.svg";
import BottomShadowImage from "../../../assets/images/supplierPayments/landing 1x bottom shadow svg.svg";
import { initialStepperlist } from "../UnderwritingSections/UnderwritingSections";
import { useAppDispatch, useAppSelector } from "../../../redux/reduxHooks";
import { setRefreshUwHome } from "../../../redux/underwriting/underwriting";

// import LandingPnlImage from '../../../assets/images/supplierPayments/landing 2x.png';

// const helpPoints = [
//   "Get financed through WhatsApp",
//   "Disbursement in just 90 minutes",
//   "Safe and secure",
// ];
const helpPoints = [
  "Decide when you want to repay",
  "Rate Match Promise - Cheapest interest rate",
  "Upto ₹10cr in just 4 days",
];

const BtnText = {
  [UnderwritingColdState.inProgress]: "In Progress",
};

const UnderwritingHome = () => {
  const navigate = useNavigate();
  const pageTitle = usePageTitle("Merito Credit | Merito");
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [getStartedLoading, setGetStartedLoading] = useState(false);
  const [uwColdState, setUwColdState] = useState(null);
  const [userDetails, setUserDetails] = useState(null);

  const { setHeaderContent, resetHeaderContent } = useOutletContext<any>();

  const { refreshUwHome } = useAppSelector((state) => state.underwriting);
  const dispatch = useAppDispatch();

  useEffect(() => {
    setHeaderContent(
      <HeaderTitle isNav={false} headerTitle={`Merito Credit`} />
    );
    return () => {
      resetHeaderContent();
    };
  }, []);

  useEffect(() => {
    if (searchParams.get("token")) {
      searchParams.delete("token");
      setSearchParams(searchParams);
    }
    // if (update?.updateAvailable) {
    const bodyElement = document.getElementsByTagName("body")[0];
    bodyElement.style.overflowY = "hidden";
    const pageIndexLayout: any = document.getElementById("page_body");
    if (pageIndexLayout) {
      // pageIndexLayout.style.overflowY = "hidden";
      pageIndexLayout.style.padding = "0rem";
    }

    return () => {
      const bodyElement = document.getElementsByTagName("body")[0];
      const pageIndexLayout: any = document.getElementById("page_body");
      if (pageIndexLayout) {
        pageIndexLayout.style.overflowY = "scroll";
        pageIndexLayout.style.padding = "1rem 1.5rem 2rem 1.5rem";
      }
      pageTitle("");
    };
    // }
  }, []);

  const checkAndSetJourneyStatus = async () => {
    const { coldState, underwritingFormData, allowGetStarted, userDetails } =
      await RestS.checkUnderwritingJourney();
    if (coldState == UnderwritingColdState.accessDenied) {
      navigate("/404", {
        replace: true,
      });
    } else if (coldState == UnderwritingColdState.inProgress) {
      setUserDetails(userDetails);
      setUwColdState(coldState);
    } else if (coldState == UnderwritingColdState.pendingState) {
      navigate(underwritingRoutes.underwritingStatus, {
        replace: true,
      });
    } else {
      setUwColdState(coldState);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        await checkAndSetJourneyStatus();
        // }
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (refreshUwHome) {
      checkAndSetJourneyStatus();
      dispatch(setRefreshUwHome(false));
    }
  }, [refreshUwHome]);

  const initialStepperListObj = useMemo(() => {
    return initialStepperlist.reduce((prev, curVal) => {
      prev[curVal.name] = curVal;
      return prev;
    }, {});
  }, []);

  const handleGetStarted = async () => {
    try {
      setGetStartedLoading(true);
      const { coldState, underwritingData, allowGetStarted, userDetails } =
        await RestS.checkUnderwritingJourney();
      let submitFormData = null;
      if (coldState == UnderwritingColdState.inProgress) {
        setUserDetails(userDetails);
        setUwColdState(coldState);
      } else {
        setUwColdState(coldState);
      }
      if (!underwritingData) {
        submitFormData = {
          data: null,
          step: null,
          applicationStatus: LendingStatus.IN_PROGRESS,
          isFirstTime: true,
        };
      } else {
        // console.log('underwritingFormData', underwritingData)
        submitFormData = {
          data: underwritingData?.data,
          step: null,
          applicationStatus: LendingStatus.IN_PROGRESS,
        };
      }
      const { formStatuses, formData }: any =
        await RestS.submitUnderwritingFormData(submitFormData);
      formStatuses.splice(3, 1); // removing DIRECTOR object
      console.log("formStatuses", formStatuses);
      let incompleteStep = null;
      for (const step of formStatuses) {
        if (step.status == UnderwritingFormStatus.INCOMPLETE) {
          incompleteStep = step;
          break;
        }
      }
      console.log("incomplete step", incompleteStep);
      if (incompleteStep) {
        let navigateLink = initialStepperListObj[incompleteStep.step].link;
        console.log("navigate link", navigateLink);
        navigate(navigateLink);
      } else {
        // skip to the last step
        const lastStep = initialStepperlist[initialStepperlist.length - 1];
        // console.log('last step', lastStep)
        navigate(lastStep.link);
      }
    } catch (error) {
      console.log("error", error);
      // throw error;
    } finally {
      setGetStartedLoading(false);
    }
  };

  const journeyDataText = useMemo(() => {
    if (uwColdState == UnderwritingColdState.inProgress) {
      const userName = userDetails.name.toString().trim();
      return (
        <>
          {`${userName} is working on your brand’s Merito Credit Form.`} <br />{" "}
          {`You can view it once they’ve completed.`}
        </>
      );
    } else {
      return null;
    }
  }, [uwColdState, userDetails]);

  return (
    <div className={styles.underwritingRootContainer}>
      {loading ? (
        <div className={styles.loadingContainer}>
          <CircularLoader />
        </div>
      ) : (
        <>
          <div className={styles.leftContainer}>
            <div className={styles.homeRootContainer}>
              <div className={styles.title}>
                Accelerate Your <br />
                <span>Brand's Growth</span>
              </div>
              <div className={styles.subTitle}>
                A Customised Credit Plan, in just 10 Minutes!
              </div>
              <div className={styles.helpContainer}>
                <div className={styles.helpTitle}>
                  {/* Introducing Merito Credit! */}
                  Merito’s Sell First, Pay Later
                </div>
                <ul className={styles.listContainer}>
                  {helpPoints.map((item, index) => {
                    return (
                      <li className={styles.listItem}>
                        <CheckCircleIcon />
                        <p className={styles.listItemText}>{item}</p>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div>
              <MeritoButton
                size="lg"
                type="primary-1"
                disabled={uwColdState == UnderwritingColdState.inProgress}
                btnText={
                  uwColdState == UnderwritingColdState.inProgress
                    ? BtnText[UnderwritingColdState.inProgress]
                    : // : "Get Started Now"
                    "Apply Now"
                }
                icon={<RightIcon />}
                showLoadingWithText={true}
                loading={
                  uwColdState == UnderwritingColdState.inProgress ||
                  getStartedLoading
                }
                isIconToRight={true}
                onClick={handleGetStarted}
              />
            </div>
            {uwColdState == UnderwritingColdState.inProgress &&
              journeyDataText ? (
              <div className={styles.journeyProgressColdState}>
                {journeyDataText}
              </div>
            ) : null}
          </div>
          <div className={styles.rightContainer}>
            <div className={styles.imgContainer}>
              <img className={styles.topShadowImg} src={TopShadowImage} />
              <img className={styles.landingImg} src={LandingImage} alt="" />
              <img
                className={styles.bottomShadowIamge}
                src={BottomShadowImage}
              />

              {/* <img src={LandingPnlImage} alt="" /> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UnderwritingHome;
